
export const cannotResolveOptionType = {
    NO_RESPONSE_NEEDED: 'NO_RESPONSE_NEEDED',
    REROUTE: 'REROUTE',
    ESCALATE: 'ESCALATE',
    INTERNAL_NOTE: 'INTERNAL_NOTE',
    SKIPPED: 'SKIPPED',
    ASSIGNEE_CHANGED_ON_SOURCE: 'ASSIGNEE_CHANGED_ON_SOURCE',
};